import React from "react"

export default function Cookies() {
  return (
    <>
      <section>
        <div className="overlay flex items-center justify-center text-center"></div>
      </section>

      <div className="privacy__policy pt-20 md:pt-40 pb-10 px-5 text-gray-800 bg-gray-50 2xl:px-0">
        <article className="xl:max-w-5xl xl:mx-auto">
          <h1>Generic Cookie Policy Template</h1>
          <p>
            Please read this cookie policy (“cookie policy”, "policy") carefully
            before using [website] website (“website”, "service") operated by
            [name] ("us", 'we", "our"). What are cookies?
          </p>
          <p>
            Cookies are simple text files that are stored on your computer or
            mobile device by a website’s server. Each cookie is unique to your
            web browser. It will contain some anonymous information such as a
            unique identifier, website’s domain name, and some digits and
            numbers.
          </p>

          <h4>What types of cookies do we use?</h4>
          <h4>Necessary cookies</h4>
          <p>
            Necessary cookies allow us to offer you the best possible experience
            when accessing and navigating through our website and using its
            features. For example, these cookies let us recognize that you have
            created an account and have logged into that account.
          </p>

          <h4>Functionality cookies</h4>
          <p>
            Functionality cookies let us operate the site in accordance with the
            choices you make. For example, we will recognize your username and
            remember how you customized the site during future visits.
          </p>

          <h4>Analytical cookies</h4>
          <p>
            These cookies enable us and third-party services to collect
            aggregated data for statistical purposes on how our visitors use the
            website. These cookies do not contain personal information such as
            names and email addresses and are used to help us improve your user
            experience of the website.
          </p>

          <h4>How to delete cookies?</h4>
          <p>
            If you want to restrict or block the cookies that are set by our
            website, you can do so through your browser setting. Alternatively,
            you can visit www.internetcookies.org, which contains comprehensive
            information on how to do this on a wide variety of browsers and
            devices. You will find general information about cookies and details
            on how to delete cookies from your device.
          </p>

          <h4>Contacting us</h4>
          <p>
            If you have any questions about this policy or our use of cookies,
            please contact us
          </p>
        </article>
      </div>
    </>
  )
}
